// @flow

import React from 'react';
import { Tooltip } from 'react-tippy-without-bugs';

type Props = {
  title: string,
  disabled?: boolean,
  children?: any,
  position?: string,
};

const TooltipComponent = (props: Props) => (
  <Tooltip
    title={props.title}
    animation="fade"
    distance={20}
    position={props.position ? props.position : 'top'}
    arrow
    disabled={props.disabled}
  >
    {props.children}
  </Tooltip>
);

export default TooltipComponent;
